import { TagPicker } from "rsuite";
import "./TagPicker.css";
import { forwardRef, useRef } from "react";

const SCTagPicker = forwardRef(({ errorMessage, hasError, ...props }, ref) => {
  const containerRef = useRef(null);
  return (
    <div ref={containerRef} style={{ position: "relative" }}>
      <TagPicker container={() => containerRef.current} {...props} ref={ref}>
        {props.children}
      </TagPicker>
    </div>
  );
});

export default SCTagPicker;
